import React, { useEffect } from 'react';
import { LoaderIndeterminateCircular } from '@stashinvest/react-components';
import { useSelector, useDispatch } from 'react-redux';
import { NoInvestAccount } from 'stash/components/sign-up/bank/BankErrorScreen';
import { getRegistrationEligibility } from '../actions';
import ValuePropScreen from 'stash/components/sign-up/bank/ValuePropScreen';
import {
	noInvestAccountCtaClick,
	noInvestAccountScreenView,
} from 'stash/actions/debitSignUpTrackingEvents';
import { ReduxEligibility } from 'stash/types/redux/entities/bank';
import { Entities } from 'stash/types/redux/entities';

export const EligibilityRoute = () => {
	const dispatch = useDispatch();
	const eligibility: ReduxEligibility = useSelector(
		(state: { entities?: Entities }) =>
			state?.entities?.bank?.eligibility ?? {}
	);

	useEffect(() => {
		if (!eligibility.status) {
			dispatch(getRegistrationEligibility());
		}
	}, [dispatch, eligibility.status]);

	if (!eligibility.status) {
		return (
			<div className="flex justify-center">
				<LoaderIndeterminateCircular />
			</div>
		);
	}

	if (eligibility.status === 'notEligible') {
		return (
			<NoInvestAccount
				handleMount={() => dispatch(noInvestAccountScreenView())}
				handleCtaClick={() => dispatch(noInvestAccountCtaClick())}
			/>
		);
	}

	if (eligibility.status === 'eligible') {
		return <ValuePropScreen />;
	}

	return null;
};

export default EligibilityRoute;
